if (!globalThis.process && process.env.SANDBOX_CLIENT != '0') {
    globalThis.process = {
        env: {
            SANDBOX_CLIENT: '1'
        }
    };
}
export const IS_SANDBOX = process.env.SANDBOX_CLIENT == '0';
export const IS_CLIENT = !IS_SANDBOX;
export var IS_DEBUG = false;
export function setDebug(debug) {
    IS_DEBUG = debug;
}
export const PRETTY_OUTPUT = false;
export const SHOW_FRAME = false;
